"use strict";

import { horizontallyScrollElementIntoView } from "./helpers/horizontallyScrollElementIntoView";
import { handleResponsiveBreakpoint } from "./responsiveHandler";

const classNames = {
    active: "active",
    navLink: "nav-link",
};

export class AsideNavigation {
    private nav: HTMLElement;
    private navList: HTMLElement;
    private activeAsideNavLink: HTMLLinkElement;
    private hasTimelineStyles: boolean;

    constructor() {
        this.nav = document.querySelector(".aside-nav");

        if (!this.nav) {
            return;
        }

        this.navList = this.nav.querySelector(".nav-list");
        this.activeAsideNavLink = this.nav.querySelector(`.${classNames.navLink}.${classNames.active}`);
        this.hasTimelineStyles = false;

        handleResponsiveBreakpoint(this.onMobileView.bind(this));
    }

    private calcWidthsSum(navLinks: NodeListOf<HTMLLinkElement>) {
        const initialValue = 0;
        return Array.from(navLinks).reduce((accumulator, currentValue: HTMLLinkElement) => {
            const marginLeft = parseFloat(window.getComputedStyle(currentValue).marginLeft) || 0;
            return accumulator + currentValue.offsetWidth + marginLeft;
        }, initialValue);
    }

    /* set timeline styles (mobile/tablet style of aside nav) */
    private setTimelineStyles() {
        const mobileTopNavLinks: NodeListOf<HTMLLinkElement> = this.nav.querySelectorAll(
            `.${classNames.navLink}:nth-child(odd)`,
        );
        const mobileBottomNavLinks: NodeListOf<HTMLLinkElement> = this.nav.querySelectorAll(
            `.${classNames.navLink}:nth-child(even)`,
        );

        // calc the width sum of top and bottom nav links
        const mobileTopNavLinksWidthsSum = this.calcWidthsSum(mobileTopNavLinks);
        const mobileBottomNavLinksWidthsSum = this.calcWidthsSum(mobileBottomNavLinks);

        // calc the total width including the gaps
        const maxLinksWidthPerRow = Math.max(mobileTopNavLinksWidthsSum, mobileBottomNavLinksWidthsSum);
        const maxLinksPerRow =
            mobileTopNavLinksWidthsSum > mobileBottomNavLinksWidthsSum
                ? mobileTopNavLinks.length
                : mobileBottomNavLinks.length;
        const columnGap = parseFloat(window.getComputedStyle(this.navList).columnGap) || 0;

        this.nav.style.setProperty("--max-width", `${maxLinksWidthPerRow + columnGap * (maxLinksPerRow - 1)}px`);

        horizontallyScrollElementIntoView(this.activeAsideNavLink);
    }

    private onMobileView() {
        if (this.hasTimelineStyles) {
            return;
        }

        setTimeout(() => {
            this.setTimelineStyles();
            this.hasTimelineStyles = true;
        }, 100);
    }
}
